import { Api, Auth } from '~/services'


export function fetchProfileData( user_id ) {

	return ( dispatch, getStore ) => {

		var data = {}
		if( Auth.getToken() ) data.secure_token = Auth.getToken()

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_PROFILE'
				})

				Api.get( '/wp/profile' + (!!user_id ? '/'+user_id : ''), data, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					let passedData = {
						type: 'RECEIVE_PROFILE',
						activity: data.activity
					}
					if( 'interests' in data ) passedData.interests = data.interests
					if( 'bookmarks' in data ) passedData.bookmarks = data.bookmarks
					if( 'user' in data ) passedData.user = data.user
					dispatch(passedData)
				})

			}
			
		)
	}
	
}


export function uploadProfilePicture( avatar ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SESSION'
				})

				Api.uploadFormData( 'post', '/wp/user/avatar', {
					avatar: avatar,
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_SESSION',
						user: data
					})
				})

			}
			
		)
	}
	
}


export function claimBadgeUnlock( badge_id, newLevel ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !badge_id || !newLevel ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SESSION'
				})

				Api.put( '/wp/badge/'+badge_id+'/level/'+newLevel+'/claim', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_SESSION',
						user: data.user
					})
				})

			}
			
		)
	}
	
}


export function setPassword( password, cpassword, old_password ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !password || !cpassword ) return;

		var data = {
			secure_token: Auth.getToken(),
			password: password,
			cpassword: cpassword
		}
		if( old_password ) data.old_password = old_password

		return dispatch(
			dispatch => {

				Api.post( '/wp/user/password', data, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_SESSION',
						user: data.user
					})
				})

			}
		)
	}
}


export function changeEmailFrequency( frequency ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !frequency ) return;

		return dispatch(
			dispatch => {

				Api.put( '/wp/user/email-frequency/' + frequency, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_SESSION',
						user: data
					})
				})

			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/actions/profiles.js